import { useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { tokens } from "../../../../../../theme";
import CallMe from "../../Popups/CallMe/CallMe";
import "./FooterMenu.css";

const FooterMenu: React.FC = () => {
  const theme = useTheme(); // Access the current theme
  const colors = tokens(theme.palette.mode);
  const [openCallMe, setOpenCallMe] = React.useState(false);
  let color = theme.palette.mode;
  const redirectUrl: string = useSelector(
    (state: any) => state.headers.redirectUrl
  );

  useEffect(() => {
    // Set CSS variables based on the current theme colors
    document.documentElement.style.setProperty(
      "--header-bg-color",
      colors.headers.backround
    );
    document.documentElement.style.setProperty(
      "--header-text-color",
      colors.headers.text
    );
    document.documentElement.style.setProperty(
      "--box-shadow",
      colors.headers.boxShadow
    );
    document.documentElement.style.setProperty(
      "--primary-color",
      colors.primaryAccent.color
    );
  }, [theme]);

  return (
    <>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div className="footer-palette">
        
            <div className="footer-items-flex"  onClick={() => setOpenCallMe(true)}>
              <i className="bi bi-telephone-fill"></i>
              <p>Call Me</p>
            </div>
         
          <CallMe open={openCallMe} onClose={() => setOpenCallMe(false)} />

          <Link to={`${redirectUrl}/desktop/live-agent`} style={{textDecoration: 'none', color: 'var(--header-text-color)'}}>
            <div className="footer-items-flex">
              <i className="bi bi-chat-left-fill"></i>
              <p>Chat with Agent</p>
            </div>
          </Link>

          <Link to={`${redirectUrl}/desktop/raise-ticket`} style={{textDecoration: 'none', color: 'var(--header-text-color)'}}>
            <div className="footer-items-flex">
              <i className="bi bi-ticket-detailed-fill"></i>
              <p>Raise Ticket</p>
            </div>
          </Link>

          <Link to={`${redirectUrl}/desktop/ticket-status`} style={{textDecoration: 'none', color: 'var(--header-text-color)'}}>
            <div className="footer-items-flex">
              <i className="bi bi-ticket-perforated-fill"></i>
              <p>Ticket Status</p>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default FooterMenu;
